import { OuDetailsTab } from './ouDetailsTab';

require('./ouDetailsTab.scss');

export const myOuDetailsTab = {
  template: require('./ouDetailsTab.html'),
  controllerAs: 'ctrl',
  controller: OuDetailsTab,
};
